const baseUrl = 'https://live.webfleet.com/web/data/img/vehicles/'

const vehicleColor = v => v.vehiclecolor?.length ? v.vehiclecolor : 'white'
const vehicleType = v => v.vehicletype || 'car_station_wagon'
const getUrlImg = v => `${baseUrl}${vehicleType(v)}_${vehicleColor(v)}.svg`

export {
  getUrlImg
}
